// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDsd8rN7ky7wnX3Q60LagSePnLkonbedBQ",
  authDomain: "supremebot-c97fd.firebaseapp.com",
  projectId: "supremebot-c97fd",
  storageBucket: "supremebot-c97fd.firebasestorage.app",
  messagingSenderId: "516995872366",
  appId: "1:516995872366:web:84be0a37f8a7b43e85187f",
  measurementId: "G-Q8B3K1EZ54"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
const auth = getAuth(app)
const db = getFirestore(app);

export { app, auth, db };